import APIClient from '@/shared/http/clients/api'

const resourceName = 'fila-atendimento'
const APICore = process.env.APIBaseURLCore

const GetAllPaging = (config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/`, config)

const GetById = (id, config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/${id}`, config)

const Create = (data, config = {}) =>
  APIClient.post(`${APICore}/${resourceName}/`, data, config)

const ChangeStatus = (id, newStatus, config = {}) =>
  APIClient.patch(`${APICore}/${resourceName}/${id}/status`, JSON.stringify(newStatus), {
    headers: { 'Content-Type': 'application/json' },
    ...config
  })

// 🔽 Agora passa o idPa via params
const GetFilaEmEspera = (idPa, config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/em-espera?idPa=${idPa}`, config)

const GetByIdFilaEmEspera = (idUsuarioAtendente, idPa, config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/em-espera/${idUsuarioAtendente}?idPa=${idPa}`, config)

const GetByIdFilaEmEsperaPreferencial = (idUsuarioAtendente, idPa, config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/em-espera/preferencial/${idUsuarioAtendente}?idPa=${idPa}`, config)

const GetUltimosChamados = (config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/ultimos-chamados`, config)

const GetByIdUltimosChamados = (idUsuarioAtendente, idPa, config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/ultimos-chamados/${idUsuarioAtendente}?idPa=${idPa}`, config)

const GetByIdHistorico = (idUsuarioAtendente, idPa, config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/historico/${idUsuarioAtendente}?idPa=${idPa}`, config)

const FilaAtendimentoRepository = {
  GetAllPaging,
  GetById,
  Create,
  ChangeStatus,
  GetFilaEmEspera,
  GetUltimosChamados,
  GetByIdFilaEmEspera,
  GetByIdUltimosChamados,
  GetByIdHistorico,
  GetByIdFilaEmEsperaPreferencial
}

export default FilaAtendimentoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/nxSenhas/fila.js